import {useSelector} from 'react-redux';
import {withRouter} from 'react-router';
import {IntlProvider} from 'react-intl';

import '@resurs/tron/dist/css/tron-font.css';
import './App.scss';
import './styles/general-styles.css';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-relativetimeformat/polyfill';

import '@formatjs/intl-relativetimeformat/locale-data/sv';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/fi';
import '@formatjs/intl-relativetimeformat/locale-data/nb';
import '@formatjs/intl-relativetimeformat/locale-data/nn';
import '@formatjs/intl-relativetimeformat/locale-data/da';

import '@formatjs/intl-pluralrules/locale-data/sv';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/fi';
import '@formatjs/intl-pluralrules/locale-data/nb';
import '@formatjs/intl-pluralrules/locale-data/nn';
import '@formatjs/intl-pluralrules/locale-data/da';

// This needs to be built first, do npm run buildintl to get data.json
import localeData from '../localization/locales/data.json';

import ConfirmRoute from './containers/Confirm/ConfirmRoute';
import SubscribeRoute from './containers/Subscribe/SubscribeRoute';
import ErrorRoute from './containers/Error';
import TimeoutRoute from './containers/Timeout';
import Navbar from './components/Navbar/Navbar';

const App = () => {
  const {locale} = useSelector((state) => state.cwa);

  const getLanguage = () => {
    const withoutRegion = locale.toLowerCase().split(/[_-]+/)[0];
    return localeData[withoutRegion];
  };

  return (
    <IntlProvider locale={locale} messages={getLanguage()}>
      <>
        <Navbar />
        <ErrorRoute />
        <TimeoutRoute />
        <ConfirmRoute />
        <SubscribeRoute />
      </>
    </IntlProvider>
  );
};

export default withRouter(App);
